import React, { useState, useEffect } from 'react';
import { CreateNew } from 'root/admin/components';

import { Table, Column } from '@smartplatform/ui';
import store from '../../store';

const tabName = 'links';

export default ({ rootPath }) => {
	const [records, setRecords] = useState([]);
	
	useEffect(() => {
		(async function() {
			const records = await store.model.Link.find({
				include: ['tags'],
				order: 'id asc'
			});
			setRecords(records);
		})();
	});

	const tags = record => record.tags().map(tag =>
		<span style={{ paddingRight: '5px' }} key={`tag-${tag.id}`}>{tag.name}</span>
	);

	return (
		<div>
			<CreateNew link={`${rootPath}/${tabName}/new`} name="Новая ссылка" />
			{records.length > 0 ?
				<Table records={records} rootPath={rootPath}>
					<Column property="name" label="Название" />
					<Column property="link" label="Ссылка" />
					<Column label="Категории">{tags}</Column>
				</Table>
				:
				''
			}
		</div>
	);
};
